module.exports = __webpack_public_path__ + "img/8c084b3413674e170380cd5582be0b8a280b6fba.70607752.png";